export class ApiError extends Error {
  status: number = 0
  url: string = ''
  errorCode: number = 0

  constructor(
    message: string,
    status: number,
    url?: string,
    errorCode?: number
  ) {
    super(message)
    this.status = status
    if (url) this.url = url
    if (errorCode) this.errorCode = errorCode
  }
}
